import React from 'react';
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import TransformationPage from "./pages/TransformationPage";
import BrandingPage from "./pages/BrandingPage";
import SecurityPage from "./pages/SecurityPage";
import DataAnalyticsPage from "./pages/DataAnalyticsPage";
import DevelopmentPage from "./pages/DevelopmentPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import WhatsAppInboxPage from "./pages/WhatsAppInboxPage";
import UserDataDeletionPage from "./pages/UserDataDeletionPage";
import SupportChat from "./components/SupportChat";
import LeadsPage from "./pages/LeadsPage";
import InboxSettingsPage from "./pages/InboxSettingsPage";

function App() {
  const location = useLocation();
  const isStandaloneDemo = location.pathname.startsWith("/demo/");

  React.useEffect(() => {
    const robotsMeta = document.querySelector<HTMLMetaElement>('meta[name="robots"]');

    if (!robotsMeta) return;

    robotsMeta.content = isStandaloneDemo
      ? "noindex, nofollow, noarchive, nosnippet"
      : "index, follow";
  }, [isStandaloneDemo]);

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />}></Route>
        <Route
          path="/digital-transformation"
          element={<TransformationPage />}
        ></Route>
        <Route path="/web-development" element={<DevelopmentPage />}></Route>
        <Route path="/data-analytics" element={<DataAnalyticsPage />}></Route>
        <Route path="/digital-branding" element={<BrandingPage />}></Route>
        <Route path="/cyber-security" element={<SecurityPage />}></Route>
        <Route path="/terms-and-conditions" element={<TermsPage />}></Route>
        <Route path="/privacy-policy" element={<PrivacyPage />}></Route>
        <Route path="/inbox" element={<WhatsAppInboxPage />}></Route>
        <Route path="/leads" element={<LeadsPage />}></Route>
        <Route path="/inbox-settings" element={<InboxSettingsPage />}></Route>
        <Route path="/user-data-deletion" element={<UserDataDeletionPage />}></Route>
      </Routes>
      {!isStandaloneDemo && <SupportChat />}
    </>
  );
}

export default App;
